import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './loginPage.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { APP_VERSION } from './appVersion';
import { migrateLegacyStorageKeys } from './utils/storageMigration';

migrateLegacyStorageKeys();

const VERSION_KEY = 'de_app_version';

async function purgeStaleCaches() {
  if (typeof caches === 'undefined') return;
  const keys = await caches.keys();
  await Promise.all(keys.map((key) => caches.delete(key)));
}

try {
  const prev = localStorage.getItem(VERSION_KEY);
  if (prev && prev !== APP_VERSION) {
    localStorage.setItem(VERSION_KEY, APP_VERSION);
    purgeStaleCaches()
      .catch(() => {})
      .finally(() => {
        const url = new URL(window.location.href);
        url.searchParams.set('v', APP_VERSION);
        window.location.replace(url.toString());
      });
  } else if (!prev) {
    localStorage.setItem(VERSION_KEY, APP_VERSION);
  }
} catch (_err) {
  /* ignore private mode */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
